import { IconInfoCircle } from "@tabler/icons-react";
import React from "react";

export const Banner = ({
  title,
  description,
  variant,
}: {
  title: string;
  description: string;
  variant: "info";
}) => {
  return (
    <div
      className="bg-blue-100 border-t-3 border-sky-500 text-sky-700 px-2 py-3 text-sm"
      role="alert"
    >
      <div className="flex items-center">
        <div className="p-2 text-sky-700">
          <IconInfoCircle />
        </div>
        <div>
          <p className="font-bold">{title}</p>
          <p className="text-sm">{description}</p>
        </div>
      </div>
    </div>
  );
};
